<template>
  <div >
    <div class="mb-12 text-16px whitespace-nowrap w-full">
      <span class="tab " v-for="tab in tabs" :key="tab.key" :class="{
        active: curTab === tab.key,
        hover: curTab !== tab.key,
      }" @click="curTab = tab.key">
        {{ tab.name }}
      </span>
    </div>
    <el-form :model="form">
      <el-form-item v-if="curTab == 'phone'">
        <el-input v-model="form.phone" autocomplete="off" :placeholder="$t('请输入手机号')" autofocus
          prefix-icon="iconfont icon-zhanghao">
          <el-select slot="prepend" :placeholder="$t('区号')" v-model="form.codes" class="w-7rem">
            <el-option v-for="item in codes" :key="item.id" :label="`${item.value}(${item.key})`"
              :value="item.key"></el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item v-else>
        <el-input v-model="form.email" autocomplete="off" :placeholder="$t('请输入邮箱')" autofocus
          prefix-icon="iconfont icon-zhanghao">
        </el-input>
      </el-form-item>
      <el-form-item class="">
        <el-row class="border rounded" :class="{ code_active: isActive }">
          <el-col :span="14">
            <el-input class="code" :placeholder="$t('请输入验证码')" prefix-icon="iconfont icon-yanzhengma" v-model="form.code"
              @focus="isActive = true" @blur="isActive = false" />
          </el-col>
          <el-col :span="1">
            <div class="">|</div>
          </el-col>
          <el-col :span="7" class="whitespace-nowrap overflow-hidden">
            <div class="cursor-pointer " @click="sendCode" v-if="code_show">
              {{ $t(" 发送验证码") }}
            </div>
            <div class="whitespace-nowrap" v-else>
              {{ $t("等待") }}{{ count }}s
            </div>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.password" autocomplete="off" :placeholder="$t('请设置登录密码')" show-password>
          <template #prefix><span class="iconfont icon-mima"></span></template>
        </el-input>
      </el-form-item>

      <el-button type="primary" @click="register" class="w-full" :disabled="btnState">
        {{ $t(" 提交注册") }}
      </el-button>

      <!-- <p class="text-sm mt-6">
        <el-link type="info" :underline="false">—— {{ $t("快捷登录") }} ——</el-link>
      </p> -->
    </el-form>
  </div>
</template>

<script>
import { reactive, ref, onMounted, computed } from "@vue/composition-api";

import { defineComponent } from "@vue/runtime-dom";

export default defineComponent({
  setup(props, ctx) {
    const curTab = ref('phone')
    const tabs = reactive([
      {
        key: 'phone',
        name: ctx.root.$t("手机注册"),
      },
      {
        key: 'email',
        name: ctx.root.$t("邮箱注册"),
      },
    ]);
    const form = reactive({
      //区号
      phone: '',
      email: '',
      codes: "",
      email_phone: "",
      password: "",
      code: "",
    });
    const codes = ref();
    onMounted(async () => {
      const res = await ctx.root.$lazy("datadic");
      codes.value = res.countryareacode;
    });
    // const regPhone =
    //   /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
    // const regEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    const isActive = ref(false);
    const code_show = ref(true);
    const count = ref();
    const whenSendcode = () => {
      ctx.root.$doing(ctx.root.$t("验证码已发送"));
      code_show.value = false;
      ctx.root.$done();
      const countDown = 60;
      count.value = countDown;
      const timer = setInterval(() => {
        if (count.value > 0 && count.value <= 60) {
          count.value--;
        } else {
          clearInterval(timer);
          code_show.value = true;
        }
      }, 1000);
    };
    const sendCode = async () => {
      let { phone, codes, email } = form
      if (curTab.value == 'phone') {
        if (!codes) {
          return ctx.root.$toast(ctx.root.$t("请选择区号"), "warning");
        }
        if (!phone) {
          return ctx.root.$toast(ctx.root.$t('请填写手机号', 'warning'))
        }
        const re_phone = await ctx.root.$callapi("sendVerifyPhone", {
          phone: codes +'-'+ phone,
          usetype: "register",
        });
        if (re_phone.code == 0) {
          whenSendcode();
        }
      } else {
        if (!email) {
          return ctx.root.$toast(ctx.root.$t('请填写邮箱', 'warning'))
        }
        const re_email = await ctx.root.$callapi("sendVerifyEmail", {
          email: email,
          usetype: "register",
        });
        if (re_email.code == 0) {
          whenSendcode();
        }
      }
    }


    const btnState = computed(() => {
      return (form.code && form.password && (form.email || (form.codes && form.phone))) ? false : true
    })
    const register = async () => {
      let { phone, code, password, codes, email } = form
      ctx.root.$doing();
      const data = ref();
      if (curTab.value == 'phone') {
        data.value = {phone:codes+'-'+phone,password,verifycode:code}
      } else {
        data.value = {email,password,verifycode:code}
      }
      const res = await ctx.root.$callapi("user/register", data.value);
      ctx.root.$done();
      if (res.code === 0) {
        if (res.data.status === 0) {
          ctx.root.$toast(
            ctx.root.$t("注册成功"),
            "success"
          );
          // 去改爷爷组件的值
          hclick();
          location.reload();
        } else {
          ctx.root.$toast(
            ctx.root.$t("注册请求发送成功，等待后台审核"),
            "success"
          );
        }

      }
    };

    const hclick = () => {
      ctx.emit('change');
    };
    return {
      form,
      sendCode,
      code_show,
      count,
      btnState,
      isActive,
      register,
      codes,
      curTab,
      tabs
    };
  },
});
</script>

<style scoped lang="scss">.code ::v-deep .el-input__inner {
  border: 0;
}
.code_active {
  border-color: #34b66b;
}
.tab {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  cursor: pointer;
  display: inline-block;
  padding-bottom: 0.5rem;
  white-space: nowrap;
  width: 50%;
}
.hover:hover {
  --tw-border-opacity: 1;
  border-color: rgba(229, 231, 235, var(--tw-border-opacity));
  border-bottom-width: 2px;
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, var(--tw-text-opacity));
}
.active {
  --tw-border-opacity: 1;
  border-color: rgba(21, 186, 99, var(--tw-border-opacity));
  border-bottom-width: 2px;
  --tw-text-opacity: 1;
  color: rgba(21, 186, 99, var(--tw-text-opacity));
}</style>
